import { combineReducers } from "redux";
import gift from "../features/admin/gift_management/gift/Slice";
import user_gift from "../features/admin/gift_management/user_gift/Slice";

const gift_managements = combineReducers({
  gift: gift,
  user_gift: user_gift,
});

export default gift_managements;
